var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "report-page" }, [
    _c("div", { staticClass: "header-container" }, [
      _c("span", { staticClass: "data-box-title" }, [_vm._v(_vm._s(_vm.title))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-area-container" },
      [
        _c("report-form-area", {
          attrs: {
            "buttons-disabled": _vm.buttonsDisabled,
            "generate-button": _vm.generateButton,
            "data-to-send": _vm.dataToSend
          },
          scopedSlots: _vm._u(
            [
              {
                key: "fields",
                fn: function() {
                  return [_vm._t("reportForm")]
                },
                proxy: true
              },
              {
                key: "customButton",
                fn: function() {
                  return [_vm._t("customButton")]
                },
                proxy: true
              }
            ],
            null,
            true
          )
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-side-container scroll-fire-fox" },
          [
            _vm.historyAvailable
              ? _c("report-history-area", {
                  attrs: {
                    "history-filter": _vm.historyFilter,
                    selectedWorkspaceUUID: _vm.selectedWorkspaceUUID
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76e5da64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e5da64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/ReportPage.vue
// module id = null
// module chunks = 